import React from 'react';
import Col from '../layout/Col';
import Title from '../forms/Title';
import { useParams } from 'react-router-dom';
import { addSpacesToPascalCase, generateId, shortHandDateUTC, shortHandTimeUTC, statusColors } from '../utility/functions';
import Collapsible from '../layout/Collapsable';
import Row from '../layout/Row';
import GetState from '../GetState';
import Dot from '../Dot';
import Icon from '../forms/Icon';
import { QuestRoute } from '../api/QuestRoutes';
import LinkTo from '../forms/LinkTo';
import Loading from '../Loading';
import Page from '../layout/Page';
import Table from '../table/Table';


const UserEventLog = ({ ...props }) => {

    const { guid } = useParams();

    const [log] = GetState(QuestRoute.eventLog(guid), {
        finalCall: res => {
            return translateEvent(res)
        }
    })

    const actionIcon = (action) => ({
        'GET': 'pull',
        'PUT': 'push',
        'POST': 'push',
    }[action] || null)


    const transformURL = (URI) => {
        const hash = URI.split('#')

        if (URI.match('/audit/')) {
            return `User Audit's ${hash[1] ? addSpacesToPascalCase(hash[1]) : ''} Page`
        }

        if (URI.match('/user/')) {
            return `Customer's ${hash[1] ? addSpacesToPascalCase(hash[1]) : ''} Page`
        }

        if (URI.match('/loyaltyUser/')) {
            return `Loyalty User's ${hash[1] ? addSpacesToPascalCase(hash[1]) : ''} Page`
        }

        if (URI.match('/loyaltyMember/')) {
            return `Member's ${hash[1] ? addSpacesToPascalCase(hash[1]) : ''} Page`
        }

        return addSpacesToPascalCase(URI.replace(/\/|#/g, ''))
    }

    const translateEvent = (events) => {
        const breakdown = {}
        events.forEach(e => {
            const date = shortHandDateUTC(e.requestTime)
            if (e.actionArguments) e.actionArguments = JSON.parse(e.actionArguments);

            e.icon = <Icon icon={actionIcon(e.controllerAction)} />

            breakdown[date] ? breakdown[date].unshift(e) : breakdown[date] = [e]
        })


        Object.entries(breakdown)
            .reverse()
            .forEach(([date, audit], i) => {
                const further = [];
                let page = [];
                let currentPage = {};

                audit.filter(e => e.referrerUrl !== '/' && e.referrerUrl).forEach((e, i) => {
                    const pushTo = () => {
                        further.push({
                            timeStamp: shortHandTimeUTC(currentPage.requestTime),
                            page: currentPage.referrerUrl,
                            label: <Row><span>{shortHandTimeUTC(currentPage.requestTime)}</span> <LinkTo to={currentPage.referrerUrl} target='_blank'>{transformURL(currentPage.referrerUrl)}</LinkTo></Row>,
                            path: page
                        })
                    }

                    if (e.referrerUrl !== currentPage.referrerUrl) {
                        if (page.length) {
                            pushTo();
                            page = [];
                        }
                        currentPage = e
                    }
                    page.push(e);
                })

                breakdown[date] = further
            })

        return breakdown
    }

    if (!log) return <Loading page />

    if (log.errorMessage) {
        return log.errorMessage
    }

    return (
        <Page title='User Event Log'>

            <Table
                config={{
                    data: Object.entries(log).reverse().map(([date, audit]) => ({ date, audit })),
                    colSpacing: [15],
                    disableHighlightHover: true,
                    disableTableOptions: true,
                    headers: [
                        {
                            label: 'Date',
                            propKey: 'date',
                            type: 'date'
                        }, {
                            label: 'Requests',
                        }
                    ],
                    resultsPerPage: 1,
                    renderFormat: (event) => {
                        const { date, audit } = event;
                        return (
                            <tr key={generateId()}>
                                <td>
                                    {date}
                                </td>
                                <td>
                                    <Col>
                                        {audit.map((e, j) => (
                                            <Collapsible
                                                style={{ padding: '0.5em 0.2em' }}
                                                label={e.label}
                                                colGap={'1.5em'}
                                                key={`page-${j}`}
                                            >
                                                {e.path.reverse().map((path, k) => (
                                                    <Col key={`path-${k}`}>
                                                        <Row style={{ gap: '0.5em' }}>
                                                            {shortHandTimeUTC(path.requestTime)}
                                                            <Dot color={statusColors[path.statusCode]} />
                                                            {path.icon}
                                                        </Row>

                                                        <Row>
                                                            <b style={{ flex: '1' }}>
                                                                {addSpacesToPascalCase(path.controllerName)}
                                                            </b>
                                                        </Row>

                                                        <b style={{ flex: '1' }}>- {addSpacesToPascalCase(path.methodName)}</b>

                                                        {path.actionArguments?.model && (
                                                            <pre style={{ paddingLeft: '1em' }}>
                                                                Request Body
                                                                {JSON.stringify(path.actionArguments?.model, null, 2)}
                                                            </pre>
                                                        )}
                                                        {path.actionArguments?.query && (
                                                            <pre style={{ paddingLeft: '1em' }}>
                                                                {JSON.stringify(path.actionArguments?.query, null, 2)}
                                                            </pre>
                                                        )}
                                                    </Col>
                                                ))}
                                            </Collapsible>
                                        ))}
                                    </Col>
                                </td>
                            </tr>
                        )
                    }
                }}
            />
        </Page>
    );
}

export default UserEventLog;